export const helpLine = "9002782111";

export const nikitaAddress =
  "S2, 902, Anaa Infra’s Signature, Kormangala 1st block";

export const nikitaEmail = "nikita.agrawal0216@gmail.com";
